// Puente hacia el método nativo startGoogleSignIn que expone MainActivity.kt
// (WebAppInterface) en la app Android empaquetada. Google bloquea el login
// OAuth dentro de WebViews (error disallowed_useragent), así que ahí
// signInWithPopup no sirve: la app pide la cuenta con el Credential Manager
// nativo y devuelve el ID token de Google, que acá se canjea en Firebase Auth.

export function isNativeGoogleSignInAvailable() {
  return (
    typeof window !== 'undefined' &&
    typeof window.Android !== 'undefined' &&
    typeof window.Android.startGoogleSignIn === 'function'
  );
}

export function nativeStartGoogleSignIn() {
  return new Promise((resolve, reject) => {
    window.onGoogleSignInResult = (idToken, error) => {
      delete window.onGoogleSignInResult;
      if (error === 'cancelled') {
        const err = new Error('Inicio de sesión con Google cancelado.');
        err.code = 'auth/popup-closed-by-user';
        reject(err);
      } else if (error || !idToken) {
        reject(new Error(error || 'No se pudo iniciar sesión con Google.'));
      } else {
        resolve(idToken);
      }
    };
    window.Android.startGoogleSignIn();
  });
}
